import styled, { css } from 'styled-components';

const ErrorNoteStyled = styled.div`
  ${() => {
    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 1.5em 1em;
      margin: auto 0;
      text-align: center;
      min-height: 25em;
      .error-note__title {
        font-weight: 700;
        font-size: 1em;
        line-height: 1.5em;
        color: var(--color-neutral-60);
        margin: 0.25em 0 0 0;
      }
      .error-note__text {
        margin: 0.5em 0 0 0;
        font-weight: 400;
        font-size: 1em;
        line-height: 1.5em;
        color: var(--color-neutral-60);
      }
    `;
  }}
`;

export default ErrorNoteStyled;
